var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoProduct24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "btn_taxes_and_commision24x24",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10752",
    "data-name": "Rectangle 10752",
    width: 24,
    height: 24,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_products24x24",
    transform: "translate(0 -.014)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29007",
    "data-name": "Group 29007",
    transform: "translate(3 4.014)",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47697",
    "data-name": "Path 47697",
    d: "M242.691,82.716l2.24-2.257-2.24-2.257.361-.364a1.624,1.624,0,0,0,0-2.282,1.593,1.593,0,0,0-2.265,0l-.361.364-2.24-2.257-.661.666v1.053a2.683,2.683,0,0,1,0,5.21v3.264h-1.939l-.387.389,2.987,3.009L240.426,85l.311.314a1.6,1.6,0,0,0,2.265,0,1.624,1.624,0,0,0,0-2.282Zm0,0",
    transform: "translate(-226.93 -71.254)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47698",
    "data-name": "Path 47698",
    d: "M9.538,11.738V8.546h.44a1.614,1.614,0,0,0,0-3.227h-.44V2.128H6.371V1.614a1.6,1.6,0,1,0-3.2,0v.514H0V5.319H.44a1.607,1.607,0,0,1,1.57,1.3.549.549,0,0,1,0,.637A1.607,1.607,0,0,1,.44,8.546H0v3.192H3.168v-.514a1.6,1.6,0,1,1,3.2,0v.514Zm0,0",
    transform: "translate(0 -.014)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoProduct24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_product24x24.20edebd0fc041d9edd7d4b059ac86767.svg";